<template>
    <div class="x-header-view">
        <div class="x-header p-3">
            <div class="x-hader-title me-3">
                <h4>
                    <i class="align-middle me-2 fas fa-fw fa-arrow-left"
                        @click="()=>{ $router.go(-1) }"
                    ></i>
                    <span>DICOM Viewer</span>
                </h4>
            </div>
            <ul class="toolsBar">
                <li>
                    <div class="tools-item" 
                        @click="save"
                    >
                        <i class="align-middle mb-1 fa-regular fa-save"></i>
                        <span>儲存</span>
                    </div>
                </li>
                <li>
                    <div class="tools-item" :class="{'active':active=='Invert'}"
                        @click="toggleInvert"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-circle-half-stroke"
                            :class="{'rotate-180':viewportInvert}"
                        ></i>
                        <span>黑白反轉</span>
                    </div>
                </li>
                <li>
                    <div class="tools-item" :class="{'active':active=='Pan'}"
                        @click="enabledPanTool"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-arrows-alt"></i>
                        <span>移動</span>
                    </div>
                </li>
                <li>
                    <div class="tools-item" :class="{'active':active=='ZoomIn'}"
                        @click="toggleZoomIn"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-search-plus"></i>
                        <span>放大</span>
                    </div>
                </li>
                <li>
                    <div class="tools-item" :class="{'active':active=='ZoomOut'}"
                        @click="toggleZoomOut"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-search-minus"></i>
                        <span>縮小</span>
                    </div>
                </li>
                <li>
                    <div class="tools-item" :class="{'active':active=='Length'}"
                        @click="enabledLengthTool"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-ruler-vertical"></i>
                        <span>長度</span>
                    </div>
                </li>

                <li>
                    <div class="tools-item" :class="{'active':active=='Angle'}"
                        @click="enabledAngleTool"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-ruler-combined"></i>
                        <span>角度</span>
                    </div>
                </li>

                <li>
                    <div class="tools-item" :class="{'active':active=='RectangleRoi'}" 
                        @click="enabledRectangleRoiTool"
                    >
                        <i class="align-middle mb-1 fa-regular fa-square"></i>
                        <span>矩形選取</span>
                    </div>
                </li>

                <li>
                    <div class="tools-item" :class="{'active':active=='EllipticalRoi'}" 
                        @click="enabledEllipseRoiTool"
                    >
                        <i class="align-middle mb-1 fa-regular fa-circle"></i>
                        <span>橢圓選取</span>
                    </div>
                </li>

                <li>
                    <div class="tools-item" :class="{'active':active=='passive'}" 
                        @click="enabledEraserTool"
                    >
                        <i class="align-middle mb-1 fas fa-fw fa-eraser"></i>
                        <span>刪除</span>
                    </div>
                </li>

                <!-- <li>
                    <div class="tools-item"
                    >
                        <span class="fw-bold">VHS</span>
                    </div>
                </li>
                <li>
                    <div class="tools-item"
                    >
                        <span class="fw-bold">VHS</span>
                    </div>
                </li> -->

            </ul>
        </div>
        <div class="dicom-view">
            <div class="record-x-list">
                <ul class="side-view">
                    <li v-for="(xRay,index) in xRayList" :key="index"
                        class="side-item"
                        :class="{'select':$shared.getFilePath(xRay.imgPath) == path}"
                        @click="selectXRay($shared.getFilePath(xRay.imgPath),xRay.json)"
                    >
                        <div class="side-content" :id="`xRay_${index}`"></div>
                    </li>
                </ul>
            </div>
            <div class="main-view" id="cornerstone">
                
            </div>
        </div>
    </div>
</template>
<script>
//參考資料
import dicomParser from 'dicom-parser';
import cornerstone from 'cornerstone-core';
import cornerstoneMath from 'cornerstone-math';
import cornerstoneTools from 'cornerstone-tools'
import Hammer from 'hammerjs';
import cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader'
cornerstoneTools.external.cornerstone = cornerstone
cornerstoneTools.external.Hammer = Hammer
cornerstoneTools.external.cornerstoneMath = cornerstoneMath
cornerstoneWebImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
export default {
    name: 'x-ray',
    data(){
        return {
            id:parseInt( this.$route.params.id ),
            path: this.$route.params.path ? this.$route.params.path : null,
            element:null,
            deleIcon: require('@/assets/img/eraser-solid.png'),
            deleteMeasurementHandler: null,  // 保存事件處理器
            imageUrl:null,
            tools:{},
            imgShape:[],
            imgData:[],
            toolState:null,
            active:'Invert',
            viewportInvert:true,
            scale:null,
            examData:{
                exam_type:0,
                booked_exam_date:'',
                complete_time:'',
                exam_group_id:0,
                exam_type:0,
                exam_unit:0,
                form_send_time:'',
                json_data:[],
                note:'',
                result_file_url:'',
                specimen_type:'',
                status_id:0,
                form_file_name:'',
                form_file_url:'',
                result_file_name:''
            },
            xRayList:[],
            minElement:[],
            minImageUrl:[],
            minImgShape:[],
            minImgData:[]
        }
    },
    methods:{
        async initView(){
            //取得x光檢驗資料
            this.$store.state.loadingStatus = true
            const res = await this.$api.exam.getExaminationResultInsideDetail({
                exam_inside_id:this.id
            })
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 || res == null ){
                return
            }
            this.examData = res.data
            this.xRayList = JSON.parse(this.examData.result_file_url)
            console.log( `xRayList=` , this.xRayList )

            //初始化Dicom檔
            await this.createDicomView();
            setTimeout(async()=>{
                for (let index = 0; index < this.xRayList.length; index++) {
                    this.minElement.push(null)
                    this.minImageUrl.push(null)
                    this.minImgShape.push(null)
                    this.minImgData.push(null)
                    await this.createMinDicomView(index)    
                }
            },500)
            
            
        },

        async createMinDicomView(index){
            this.minElement[index] = document.querySelector(`#xRay_${index}`)
            // localStorage.setItem("debug", "cornerstoneTools");
            if (!this.minElement[index]) {
                console.error(`DOM element with id xRay_${index} not found.`);
                return;
            }
        
            // // 啟用 Cornerstone 元素
            cornerstone.enable(this.minElement[index]);
            if ( this.xRayList[index] == null ){
                return
            }
            try {
                // 使用 fetch 獲取 DICOM 文件
                const imgPath = this.$shared.getFilePath(this.xRayList[index].imgPath)
                const response = await fetch(this.$api.files.getImage(imgPath));
                
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // console.log(`response:`,response)
                // 以 Blob 形式讀取響應
                const blob = await response.blob();
                if (!blob.size) {
                    throw new Error('Empty DICOM file returned');
                }

                const imageUrl = URL.createObjectURL(blob);  // 創建 Blob URL
                this.minImageUrl[index] = imageUrl
                const imageId = `wadouri:${imageUrl}`;  // 使用 WADO-URI 加載格式

                // 加載 DICOM 影像
                const image = await cornerstone.loadAndCacheImage(imageId);
                // this.$debug('DICOM image loaded:', image);
                this.minImgShape[index] = [image.width,image.height]
                this.minImgData[index] = image.getPixelData()
                cornerstone.displayImage(this.minElement[index], image);  // 顯示影像

                //初始化大小
                const viewport = cornerstone.getViewport(this.minElement[index]);
                // this.$debug(`viewport.scale:`,viewport.scale)
                this.scale = viewport.scale

            } catch (error) {
                // console.error('Error fetching or loading DICOM file:', error);
            }
            
        },
        async createDicomView(){
            this.element = document.querySelector('#cornerstone')
            // 啟用工具 - 這裡初始化並啟用長度測量工具
            cornerstoneTools.init({
                touchEnabled: true,
                mouseEnabled: true,
                globalToolSyncEnabled: false,
                showSVGCursors: true,  // 啟用 SVG 光標
            });
            // 設定全域工具樣式
            console.log(`cornerstoneTools=` , cornerstoneTools)
            // Set color for inactive tools
            cornerstoneTools.toolColors.setToolColor('rgb(255, 255, 0)');
            // Set color for active tools
            cornerstoneTools.toolColors.setActiveColor('rgb(0, 255, 0)');
            cornerstone.enable(this.element);
            if ( this.path == null ){
                return
            }
            try {
                
                this.$store.state.loadingStatus = true
                // 使用 fetch 獲取 DICOM 文件
                const response = await fetch(this.$api.files.getImage(this.path));
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                this.$store.state.loadingStatus = false
                // 以 Blob 形式讀取響應
                const blob = await response.blob();
                const imageUrl = URL.createObjectURL(blob);  // 創建 Blob URL
                this.imageUrl = imageUrl
                
                const imageId = `wadouri:${imageUrl}`;  // 使用 WADO-URI 加載格式
                // 加載 DICOM 影像
                const image = await cornerstone.loadAndCacheImage(imageId);
                // this.$debug('DICOM image loaded:', image);
                this.imgShape = [image.width,image.height]
                this.imgData = image.getPixelData()
                cornerstone.displayImage(this.element, image);  // 顯示影像

                //以下測試加載資料
                const buffer = await blob.arrayBuffer();           // ArrayBuffer
                const byteArray = new Uint8Array(buffer);          // Uint8Array 給 dicomParser

                const dataSet = dicomParser.parseDicom(byteArray);
                // 取出你要的欄位，例如：
                const patientName = dataSet.string('x00100010');    // Patient’s Name
                const PatientID = dataSet.string('x00100020');    // Patient’s Name
                const studyDate   = dataSet.string('x00080020');    // Study Date
                const modality    = dataSet.string('x00080060');    // Modality
                console.log('dicom info:',{ patientName, PatientID ,studyDate, modality });

                //初始化大小
                const viewport = cornerstone.getViewport(this.element);
                
                this.scale = viewport.scale
                // 預設啟用長度測量工具
                this.enabledLengthTool();
                // return
                // 檢查是否有儲存的工具狀態
                if (!this.examData || !this.examData.result_file_url) {
                    return console.log('No saved tool state.');
                }
                this.$store.state.loadingStatus = true
                const result_file_url = JSON.parse(this.examData.result_file_url)
                const result_file_index = result_file_url.findIndex(item => this.$shared.getFilePath(item.imgPath) == this.path);
                if (result_file_index === -1) {
                    return console.log('找不到索引');
                }
                console.log(`result_file_url=`,result_file_url)
                const toolsJson = result_file_url[result_file_index].json
                console.log(`toolsJson=`,toolsJson)
                if (
                    !toolsJson ||
                    (typeof toolsJson === 'string' && (toolsJson === '{}' || toolsJson.trim() === ''))
                ) {
                    this.$store.state.loadingStatus = false;
                    return console.log('工具狀態為空或無效');
                }

                let restoreToolStateKey = `wadouri:${this.imageUrl}`;
                let toolState = {};

                console.log('toolsJson type:', typeof toolsJson);
                
                try {
                    // 嘗試解析 JSON
                    toolState[restoreToolStateKey] = typeof toolsJson === "object" ? toolsJson : JSON.parse(toolsJson);
                    console.log('成功解析工具狀態:', toolState);
                } catch (error) {
                    console.error('無法將 toolsJson 轉成 JSON：', error);
                    toolState[restoreToolStateKey] = {};
                }
                // 動態啟用所有工具
                const toolsToEnable = Object.keys(toolState[restoreToolStateKey]);

                toolsToEnable.forEach(toolName => {
                    const toolClass = cornerstoneTools[`${toolName}Tool`];
                    if (toolClass) {
                        cornerstoneTools.addToolForElement(this.element, toolClass);
                        // 啟用工具以便直接顯示
                        cornerstoneTools.setToolActiveForElement(this.element, toolName, {
                            mouseButtonMask: 1,
                        });
                    } else {
                        console.warn(`Tool not found: ${toolName}`);
                    }
                });
                await cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(toolState);
                // 更新影像顯示
                await cornerstone.updateImage(this.element);
                this.$store.state.loadingStatus = false

                // 監聽 Cornerstone 元素的滑鼠點擊事件
                this.element.addEventListener('cornerstonetoolsmeasurementcompleted', this.handleMeasurementEvent);
                this.element.addEventListener('cornerstonetoolsmeasurementmodified', this.handleMeasurementEvent);
                this.element.addEventListener('cornerstonetoolsmeasurementremoved', this.handleMeasurementEvent);
                // this.element.addEventListener('mousedown', this.handleMouseDown);
            } catch (error) {
                console.error('Error fetching or loading DICOM file:', error);
            }

            
        },
    
        async selectXRay(path, toolsJson) {

            await this.save()

            try {
                const targetElement = cornerstone.getEnabledElements().find(el => el.element.id === 'cornerstone')?.element;
                if (!targetElement) throw new Error('❌ 未找到 #cornerstone 元件');

                // 保存當前 Viewport 設置
                const currentViewport = cornerstone.getViewport(targetElement);
                const currentVoi = currentViewport.voi || { windowWidth: 400, windowCenter: 40 };

                // 獲取並載入新 DICOM 影像
                const response = await fetch(this.$api.files.getImage(path));
                if (!response.ok) throw new Error(`❌ 無法獲取 DICOM 文件，狀態碼: ${response.status}`);

                this.path = path;
                const blob = await response.blob();
                const imageUrl = URL.createObjectURL(blob);
                this.imageUrl = imageUrl;
                const imageId = `wadouri:${imageUrl}`;

                // 釋放舊影像
                const currentImage = cornerstone.getImage(targetElement);
                if (currentImage?.imageId?.startsWith('wadouri:blob:')) {
                    const oldBlobUrl = currentImage.imageId.replace('wadouri:', '');
                    URL.revokeObjectURL(oldBlobUrl);
                }

                // 載入新影像
                const image = await cornerstone.loadAndCacheImage(imageId);
                cornerstone.displayImage(targetElement, image);

                // 設置 Viewport
                const imageVoi = image.voi || { windowWidth: image.windowWidth, windowCenter: image.windowCenter };
                cornerstone.setViewport(targetElement, {
                    ...currentViewport,
                    voi: {
                        windowWidth: imageVoi.windowWidth || currentVoi.windowWidth,
                        windowCenter: imageVoi.windowCenter || currentVoi.windowCenter
                    }
                });

                // **工具狀態還原**
                if (toolsJson) {
                    console.log('🛠️ 接收的 toolsJson:', toolsJson);

                    // 確保 JSON 格式正確
                    if (typeof toolsJson === 'string') {
                        try {
                            toolsJson = JSON.parse(toolsJson);
                        } catch (error) {
                            console.error('❌ toolsJson 解析失敗:', error);
                            return;
                        }
                    }

                    // 啟用對應工具
                    Object.keys(toolsJson).forEach(toolName => {
                        const ToolClass = cornerstoneTools[`${toolName}Tool`];
                        if (ToolClass) {
                            cornerstoneTools.addToolForElement(targetElement, ToolClass);
                            cornerstoneTools.setToolActiveForElement(targetElement, toolName, { mouseButtonMask: 1 });
                        }
                    });

                    // 還原工具狀態
                    const toolState = { [imageId]: toolsJson };
                    cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(toolState);
                    console.log('✅ 工具狀態已成功恢復。');
                } else {
                    console.warn('⚠️ 無可恢復的工具狀態。');
                }

                // 更新影像以顯示工具
                cornerstone.updateImage(targetElement);

                if (this.active === 'passive'){
                    this.element.style.cursor = 'default';
                }
            } catch (error) {
                console.error('❌ 切換 DICOM 影像時發生錯誤:', error);
            }

        },

        async save(){
            this.toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
            console.log(`this.toolState=`,this.toolState)
            //處理去掉wadouri:blob
            console.log(`wadouri:${this.imageUrl}=`,this.toolState[`wadouri:${this.imageUrl}`])
            const json = JSON.stringify(this.toolState[`wadouri:${this.imageUrl}`])
            //找出 result_file_url 格式化成陣列
            const result_file_url = JSON.parse(this.examData.result_file_url)
            const result_file_index = result_file_url.findIndex(item => this.$shared.getFilePath(item.imgPath) == this.path);
            if ( result_file_index == -1 ){
                return console.log('找不到索引')
            }
            // console.log('json:' , json)
            result_file_url[result_file_index].json = json
            
            this.$store.state.loadingStatus = true
            let objFrom = new FormData()
            objFrom.append('exam_inside_id', this.id)
            objFrom.append('imgPath', result_file_url[result_file_index].imgPath)
            objFrom.append('json', json)
            const res = await this.$api.exam.updXrayJson(objFrom)
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 || res == null ){
                return
            }
            this.examData.result_file_url = JSON.stringify(result_file_url)
            this.xRayList = JSON.parse(this.examData.result_file_url)
            // console.log(`this.examData.result_file_url=` , this.examData.result_file_url)


        },

        removeJson(){
            const imageId = `wadouri:${this.imageUrl}`;
            const toolState = { [imageId]: {} };
            cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(toolState);

            // 5. 重新渲染影像
            cornerstone.updateImage(cornerstone.getEnabledElements()[0].element);
        },

        backJson() {
            // 1. 取得當前的工具狀態
            const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();
            const imageId = `wadouri:${this.imageUrl}`;
            
            if (toolState[imageId]) {
                console.log(`toolState[imageId]=`,toolState[imageId])
                // 2. 取得工具狀態中的所有工具
                Object.keys(toolState[imageId]).forEach(toolType => {
                    console.log(`toolType=`,toolType)
                    const toolData = toolState[imageId][toolType].data;
                    console.log(`toolData=` , toolData)
                    // 3. 移除最後一筆資料
                    if (toolData.length > 0) {
                        console.log(`移除掉最後一筆`)
                        toolData.pop(); // 移除最後一筆
                    }
                    console.log(`toolData=` , toolData)
                });

                // 4. 將修改後的工具狀態重新套用
                cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(toolState);
                console.log('Successfully removed the last tool state.');
            } else {
                console.log('No tool state found for this imageId.');
            }

            // 5. 重新渲染影像
            cornerstone.updateImage(cornerstone.getEnabledElements()[0].element);
        },

        toggleInvert(){
            this.active = this.active !== 'Invert' ? 'Invert' : null
            const viewport = cornerstone.getViewport(this.element);
            viewport.invert = !viewport.invert;  // 切換 invert 狀態
            this.viewportInvert = viewport.invert
            cornerstone.setViewport(this.element, viewport);  // 更新 viewport 來應用變更
        },
        enabledAngleTool(){
            this.active = this.active !== 'Angle' ? 'Angle' : null
            const AngleTool = cornerstoneTools.AngleTool;
            cornerstoneTools.addToolForElement(this.element, AngleTool);
            this.setToolActiveForElement()
        },
        enabledEraserTool(){
            this.active = 'passive'
            this.setToolActiveForElement()
            // 啟用橡皮擦模式時，綁定點擊事件以刪除目標
            this.element.style.cursor = 'default';
            // 移除舊的監聽器
            if (this.deleteMeasurementHandler) {
                this.element.removeEventListener('cornerstonetoolsmeasurementcompleted', this.deleteMeasurementHandler);
            }

            console.log(`cursor=`,this.element.style.cursor )
            // 設置新的監聽器
            this.deleteMeasurementHandler = (event) => {
                const uuid = event.detail?.measurementData?.uuid;
                if (uuid) {
                    this.deleteToolByUUID(uuid);
                }
            };

            this.element.addEventListener('cornerstonetoolsmeasurementcompleted', this.deleteMeasurementHandler);
        },
        removeDeleteMeasurementHandler() {
            if (this.deleteMeasurementHandler) {
                // this.element.style.cursor = 'default';
                this.element.removeEventListener('cornerstonetoolsmeasurementcompleted', this.deleteMeasurementHandler);
                this.deleteMeasurementHandler = null;
                console.log('🔴 已移除 Eraser 監聽事件');
            }
        },
        toggleZoomIn(){
            this.$debug(`toggleZoomOut:`,(this.scale))
            if ( this.scale >= 5 ){
                return
            }
            this.active = 'ZoomIn'
            this.scale = this.scale+0.01
            this.setZoom()
        },
        toggleZoomOut(){
            this.$debug(`toggleZoomOut:`,(this.scale))
            if ( this.scale <= 0.22606382978723405 ){
                return
            }
            this.active = 'ZoomOut'
            this.scale = this.scale-0.01
            this.setZoom()
        },
        // 設置放大倍率
        setZoom() {
            const viewport = cornerstone.getViewport(this.element);
            viewport.scale = this.scale;  // 設定放大比例
            cornerstone.setViewport(this.element, viewport);  // 更新 viewport
        },
        enabledLengthTool(){
            this.active = 'Length'
            const LengthTool = cornerstoneTools.LengthTool;
            cornerstoneTools.addToolForElement(this.element, LengthTool);
            this.setToolActiveForElement()
        },
        enabledPanTool(){
            this.active = 'Pan'
            const PanTool = cornerstoneTools.PanTool;
            cornerstoneTools.addToolForElement(this.element, PanTool);
            this.setToolActiveForElement()
        },
        enabledRectangleRoiTool(){
            this.active = 'RectangleRoi'
            const RectangleRoiTool = cornerstoneTools.RectangleRoiTool;
            cornerstoneTools.addToolForElement(this.element, RectangleRoiTool);
            this.setToolActiveForElement()
        },
        enabledEllipseRoiTool(){
            this.active = 'EllipticalRoi'
            const EllipticalRoiTool = cornerstoneTools.EllipticalRoiTool;
            cornerstoneTools.addToolForElement(this.element, EllipticalRoiTool);
            this.setToolActiveForElement()
        },
        setToolActiveForElement(){
            if (!this.element) {
                console.warn('❌ 未找到 Cornerstone 元件');
                return;
            }

            // 切換工具時移除 Eraser 監聽
            if (this.active !== 'passive') {
                this.removeDeleteMeasurementHandler();
            }

            const toolNames = cornerstoneTools.store.state.tools.map(tool => tool.name);

            if ( this.active === 'passive' ){
                // 啟用橡皮擦：將其他工具設為「被動」，僅橡皮擦為主動
                toolNames.forEach(toolName => {
                    if (toolName !== 'EraserTool') {
                        cornerstoneTools.setToolPassiveForElement(this.element, toolName);
                    }
                });
                // 設定橡皮擦為啟用狀態
                cornerstoneTools.setToolActiveForElement(this.element, 'EraserTool', {
                    mouseButtonMask: 1,
                });
            }

            if (this.active) {
                // 啟用所選工具
                cornerstoneTools.setToolActiveForElement(
                    this.element,
                    this.active,
                    {
                        mouseButtonMask: 1,
                    }, ['Mouse']
                );
                console.log(`🟢 啟用工具：${this.active}`);
            } else {
                // 取消所有工具的使用狀態
                const toolNames = cornerstoneTools.store.state.tools.map(tool => tool.name);
                toolNames.forEach(toolName => {
                    cornerstoneTools.setToolDisabledForElement(this.element, toolName);
                });

                console.log('⚫ 所有工具已停用');
            }
        },
        deleteToolByUUID(uuid) {
            const imageId = `wadouri:${this.imageUrl}`;
            const toolState = cornerstoneTools.globalImageIdSpecificToolStateManager.saveToolState();

            if (toolState[imageId]) {
                let isDeleted = false;

                // 遍歷所有工具，尋找對應 UUID 並刪除
                Object.keys(toolState[imageId]).forEach(toolName => {
                    const toolData = toolState[imageId][toolName]?.data;
                    if (toolData) {
                        const index = toolData.findIndex(item => item.uuid === uuid);
                        if (index !== -1) {
                            toolData.splice(index, 1);  // 刪除該工具項
                            console.log(`🟢 成功刪除 UUID: ${uuid} 的 ${toolName}`);
                            isDeleted = true;
                        }
                    }
                });

                if (isDeleted) {
                    // 🔄 更新並回存工具狀態
                    cornerstoneTools.globalImageIdSpecificToolStateManager.restoreToolState(toolState);
                    cornerstone.updateImage(this.element);
                    
                    // 📝 同步回原本的 toolState
                    this.toolState = { ...toolState };
                    console.log('✅ 工具狀態已成功更新並保存：', this.toolState);
                    this.save()

                } else {
                    console.warn(`⚠️ 未找到 UUID: ${uuid}，無法刪除。`);
                }
            } else {
                console.warn(`⚠️ 未找到影像 ID: ${imageId} 的工具狀態`);
            }
        }


    },
    async mounted(){
        await this.initView()
    },
    beforeUnmount() {
        this.removeDeleteMeasurementHandler();
    },
    created(){
        console.log('this.id=',this.id)
        console.log('this.path=',this.path)
    }
}
</script>
<style scoped>
.x-header-view{
    display: flex;
    flex-direction: column;
    height: 100vh; /* 確保佔滿整個視窗高度 */
}
.x-header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    background-color: #153d77;
}
.toolsBar{
    gap: 1rem;
    display: flex;
    list-style: none;
    padding: 0;
    margin-bottom: 0;
}
.tools-item{
    cursor: pointer;
    border-radius: 25%;
    background-color: #e0e0e0;
    padding: .25rem .5rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    min-width: 4.5rem;
    height: 3.75rem;
}
.x-hader-title > h4{
    color:#ffffff;
}
.tools-item > span{
    font-size: .825rem;
}
.tools-item.active,.tools-item:hover{
    color: #ffffff;
    background-color: #153d77;
    border:1px solid #ffffff;
}
.fw-bold{
    font-weight: bold !important;
}
#cornerstone {
  width: 512px;
  height: 512px;
  border: 1px solid black;
}
.rotate-180 {
    transform: rotate(180deg);
}
.dicom-view {
    flex-grow: 1; /* 填滿剩餘空間 */
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5; /* 可選背景顏色 */
    
}

#cornerstone {
    width: 100%; /* 或特定大小 */
    height: 100%; /* 讓 DICOM 視圖高度自適應 */
    border: 1px solid black;
    position: relative;
}
#cornerstone > .action-tools {
    position: absolute;
    top: 1rem;
    right: 1rem;
    list-style: none;
    padding: .5rem 1rem;
    margin: 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* gap: .5rem; */
    border-radius: 1rem;
}
#cornerstone > .action-tools > li {
    padding: 0rem .75rem;
    cursor: pointer;
    display: flex;
    align-items: center;
}
#cornerstone > .action-tools > li:not(:last-child) {
    border-right: 1px solid #c5c5c5;
    
}
.fa-arrow-left{
    cursor: pointer;
}
.record-x-list{
    flex: 0 auto;
    width: 300px;
    height: 100%;
    overflow-y: auto;
    background-color: #000000;
    border-right: 2px solid #191919;
    padding: .5rem 0;
}
.side-view{
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
}
.side-item{
    border: 2px solid #000000;
    cursor: pointer;
}
.side-item.select{
    border-color: #ffffff;
}
</style>
  